<template>
    <div class="flats-section-content">
        <div class="container">
            <div class="section-grid-inline">
                <div class="section-grid-info">
                    <div class="title">
                        <h3 v-html="apartmentsArr.section_apartments.title"></h3>
                    </div>
                    <div class="section-grid-images-desc" v-html="apartmentsArr.section_apartments.desc_images" v-if="!isMobileG"></div>
                    <div class="desc-html" v-html="apartmentsArr.section_apartments.desc"></div>
                </div>
                <div class="section-images-grid images-grid-opposite-left">
                    <div class="images-items">
                        <div class="item" v-for="(item, index) in apartmentsArr.section_apartments.images" :key="index">
                            <img :src="item.img" alt="">
                        </div>
                    </div>
                </div>
                <!-- MOBILE -->
                <div class="section-grid-images-desc" v-html="apartmentsArr.section_apartments.desc_images" v-if="isMobileG"></div>
            </div>
        </div>
    </div>
</template>

<script>
    // import svgIcon from '@/components/partials/SvgIcon.vue';
    // import promoForm from '@/components/forms/form.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'flats-section-content',
        data () {
            return {
            }
        },
        computed: mapGetters({
            apartmentsArr: 'loadApartments',
            isMobileG: 'loadisMobileGlobal',
        }),
        components: {
            // svgIcon,
            // promoForm,
        },
        methods: {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats/flats-section-content.scss';
    @import '@/styles/components/flats/respond/flats-section-content-respond.scss';
</style>